import { CancelRounded, CheckCircle, CheckCircleOutline } from "@mui/icons-material";
import { Button, Grid, Typography } from "@mui/material";
import {
  ExecutorVerificationStep,
  ExecutorVerificationStepDetails,
  ExecutorVerificationStatus,
} from "models/ExecutorVerification";
import { EXECUTOR_VERIFICATION_ACCEPTED_ID, EXECUTOR_VERIFICATION_IN_PROGRESS_ID, EXECUTOR_VERIFICATION_IN_REVIEW_ID, EXECUTOR_VERIFICATION_REJECTED_ID, EXECUTOR_VERIFICATION_SUBMITTED_ID } from ".";

interface IProps {
  step: ExecutorVerificationStep;
  stepDetails: ExecutorVerificationStepDetails | null;
  statusesMap: { [key: string]: ExecutorVerificationStatus };
  onButtonClick?: () => void;
}

export const VerificationStep = (props: IProps): JSX.Element => {
  const step = props.step;

  let stepStatusIcon = <CheckCircle htmlColor="#ccc" />;
  if (step.statusId === EXECUTOR_VERIFICATION_ACCEPTED_ID) {
    stepStatusIcon = <CheckCircle color="secondary" />;
  } else if (step.statusId === EXECUTOR_VERIFICATION_SUBMITTED_ID || step.statusId === EXECUTOR_VERIFICATION_IN_REVIEW_ID) {
    stepStatusIcon = <CheckCircleOutline color="secondary" />;
  } else if (step.statusId === EXECUTOR_VERIFICATION_REJECTED_ID) {
    stepStatusIcon = <CancelRounded htmlColor="red" />;
  }

  let buttonText = "Start";
  let buttonVariant: "contained" | "outlined" = "contained"
  if (step.statusId === EXECUTOR_VERIFICATION_SUBMITTED_ID || step.statusId === EXECUTOR_VERIFICATION_IN_REVIEW_ID) {
    buttonText = "Revisit";
    buttonVariant = "outlined"
  } else if (step.statusId === EXECUTOR_VERIFICATION_IN_PROGRESS_ID) {
    buttonText = "Continue";
  }

  return (
    <Grid container spacing={2} style={{ width: "100%", padding: "0.5rem" }}>
      <Grid
        item
        style={{
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
        }}
      >
        {stepStatusIcon}
      </Grid>
      <Grid
        item
        xs={8}
        sm={8}
        md={8}
        lg={8}
        xl={8}
        style={{
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
        }}
      >
        <Typography
          variant={"body1"}
          component={"p"}
          style={{ fontSize: "13pt", marginBottom: "0.5rem" }}
        >
          {props.stepDetails?.name || "Loading"}
        </Typography>
        <Typography variant={"body1"} component={"p"}>
          {props.stepDetails?.description || ""}
        </Typography>
      </Grid>
      <Grid
        item
        xs={2}
        sm={2}
        md={2}
        lg={2}
        xl={2}
        style={{
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
        }}
      >
        <Button
          variant={buttonVariant}
          color={"secondary"}
          style={{ width: "150px" }}
          onClick={props?.onButtonClick}
        >
          {buttonText}
        </Button>
      </Grid>
    </Grid>
  );
};
